<template>
  <div id="app-wrapper">
    <router-view :key="lang" />
    <button
      v-if="isFloatingShow"
      class="floating"
      :class="[{ double: $route.fullPath.includes('community/home') }, { main: $route.path === '/main' }]"
      @click="$router.push({ name: 'Landing' })"
    />
    <BaseModal :id="'copy-modal'" no-content @clickConfirm="clickCancel('copy-modal')">
      <template slot="title">
        {{ $t('modal.linkcopy') }}
      </template>
    </BaseModal>
    <BaseModal
      :id="'login-required'"
      cancel-btn
      @clickConfirm="clickConfirm"
      @clickCancel="clickCancel('login-required')"
    >
      <template slot="title">
        {{ $t('modal.login.title') }}
      </template>
      <template slot="content">
        {{ $t('modal.login.content') }}
      </template>
      <template slot="confirm">
        {{ $t('modal.login.confirm') }}
      </template>
    </BaseModal>
    <BaseModal :id="'logout'" no-content @clickConfirm="clickLogout">
      <template slot="title">
        {{ $t('modal.logout.title') }}
      </template>
    </BaseModal>
    <BaseModal
      :id="'nice-id-check'"
      cancel-btn
      no-content
      @clickConfirm="confirmNiceId"
      @clickCancel="clickCancel('nice-id-check')"
    >
      <template slot="title">
        {{ $t('modal.nice.title') }}
      </template>
      <template slot="confirm">
        {{ $t('modal.nice.confirm') }}
      </template>
    </BaseModal>
    <ChangeNickName />
    <form name="form_chk" method="post">
      <input type="hidden" name="m" value="checkplusService" />
      <input type="hidden" name="EncodeData" />
    </form>
    <NoticeModal :id="'notice-modal'" no-more />
    <NoticeModal :id="'urgent-modal'" />
    <!-- <ChooseLanguage /> -->
    <div v-if="omcUpdate" class="night-wrapper" style="top: 80px">
      <div class="night">
        <div v-for="i in 10" :key="i" class="shooting_star" />
      </div>
    </div>
    <no-phone v-if="showPhoneAuth" />
    <Modal id="pumpkin-modal" ref="pumpkin-modal" />
    <WinModal />
    <Modal id="global-error" ref="global-error" />
    <!-- <b-modal
      id="nyc-open-event-win-modal"
      dialog-class="nyc-open-event-win-modal"
      scrollable
      hide-header
      hide-header-close
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
    >
      <div id="nyc-open-event-win">
        <img class="fireworks" :src="`${$s3}/img/common/event/nyc_open/fireworks.webp?${$ver}`" />
        <img class="winner" :src="`${$s3}/img/${lang}/event/nyc_open/win.webp?${$ver}`" />
        <button class="go-to-regist" @click="goToRegist">
          {{ $t('nycopenevent.registbtn') }}
        </button>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import BaseModal from '@/views/Modal/BaseModal.vue';
import NoticeModal from '@/views/Modal/NoticeModal.vue';
import ChangeNickName from '@/views/Modal/changeNickName.vue';
// import ChooseLanguage from '@/views/Modal/ChooseLanguage.vue';
import WinModal from '@/views/Modal/WinModal.vue';
import Modal from '@/views/Components/Modal.vue';

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

import { authStateManager } from '@/helpers/authStateManager';

export default {
  name: 'App',
  components: {
    BaseModal,
    WinModal,
    ChangeNickName,
    NoticeModal,
    // ChooseLanguage,
    Modal,
  },
  data() {
    return {
      isOpenLangModal: false,
      modalId: 'nyc-open-event-win-modal',
      modal: null,
    };
  },
  computed: {
    ...mapState([
      'niceAuth',
      'isMobile',
      'lang',
      'localLang',
      'omcUpdate',
      'showPhoneAuth',
      'isLogin',
      'isLandingEvent',
      'isLandingEventModal',
    ]),
    ...mapGetters(['holidayDate', 'holiday', 'windowLang']),
    isFloatingShow() {
      return this.isLandingEvent && !this.$route.path.includes('landing') && !this.$route.path.includes('map');
    },
  },
  async created() {
    this.setVM({ vm: this });
    // window.addEventListener('resize', this.handleResize);
    document.body.classList.add('limit-hight');
    // window.FCMtoken = this.FCMtoken;
    window.iNoBounce.disable();
    window.store = this.$store;
    window.bvModal = this.$bvModal;
    window.axios = this.$axios;
    window.ganalytics = this.$gtag;
    this.axiosSetting();
    this.getWindowSize();
    this.getHolidayName().then(() => {});
    this.getCityName();
    // mediaQuery
    const realMobileQuery = matchMedia('(max-width: 767px)');
    const mobileQuery = matchMedia('(max-width: 1120px)');
    const tabletQuery = matchMedia('(max-width: 1345px)');

    realMobileQuery.addEventListener('change', this.setRealMobile);
    mobileQuery.addEventListener('change', this.setIsMobile);
    tabletQuery.addEventListener('change', this.setIsTablet);

    this.setRealMobile(realMobileQuery);
    this.setIsMobile(mobileQuery);
    this.setIsTablet(tabletQuery);

    authStateManager();
  },
  mounted() {
    this.setGlobalErrorModal(this.$refs['global-error']);
  },
  methods: {
    ...mapMutations(['setVM', 'setInnerHeight', 'setRealMobile', 'setIsMobile', 'setIsTablet', 'setGlobalErrorModal']),
    ...mapActions(['getHolidayName', 'getCityName', 'changeRoutePath']),
    handleResize() {
      this.$store.commit('checkMobile');
    },
    isUndefined(data) {
      return data === undefined || String(data) === 'undefined';
    },
    axiosSetting() {
      this.$axios.interceptors.response.use(
        (response) => {
          //***** localStorage에 undefined가 있다면 데이터 삭제.
          this.checkLocalStorageUndefined();

          //***** version constructor
          const headerVersion = response.headers.version;
          const localVersion = process.env.VUE_APP_VERSION;

          //***** local version이 server와 다르다면 refresh
          this.checkVersion(headerVersion, localVersion);

          //***** Announce constructor
          const headerAnnounce = response.headers.new_announcement;
          const localAnnounce = JSON.parse(localStorage.getItem('localAnnounce'));
          const readAnnounce = JSON.parse(localStorage.getItem('readAnnounce'));

          //***** Save Announcement state on localStorage(공지 빨간점)
          this.saveAnnouncement(headerAnnounce, localAnnounce);

          //***** show red dot in header(공지 빨간점)
          this.showAnnouncementRedDot(headerAnnounce, readAnnounce);

          return response;
        },
        (err) => {
          return Promise.reject(err);
        }
      );
    },
    getWindowSize() {
      const resizeEvent = () => {
        const vh = window.innerHeight * 0.01;
        this.setWindowSize(vh);

        return vh;
      };

      //***** vh가 0이면 화면이 표시되지 않으므로 refresh
      if (resizeEvent() === 0) location.reload(true);

      window.addEventListener('resize', resizeEvent);
    },
    setWindowSize(vh) {
      //***** 모바일 화면을 위한 innerHeight를 set
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      this.setInnerHeight({ innerHeight: innerHeight });
      //***** 코인이 날아가는 각도를 set
      document.documentElement.style.setProperty('--deg', this.getDegree());
      //***** 코인이 날아가는 거리를 set
      document.documentElement.style.setProperty('--diag', this.getDiagonal());
    },
    checkLocalStorageUndefined() {
      //***** localStorage에 undefined가 있는지 확인.
      const isReadAnnounce = localStorage.getItem('readAnnounce');
      const isLocalAnnounce = localStorage.getItem('localAnnounce');

      if (this.isUndefined(isReadAnnounce) || this.isUndefined(isLocalAnnounce)) {
        //***** localStorage에 undefined가 있다면 데이터 삭제.
        localStorage.removeItem('readAnnounce');
        localStorage.removeItem('localAnnounce');
      }
    },
    checkVersion(headerVersion, localVersion) {
      //***** local version이 server와 다르다면 refresh
      !this.isUndefined(headerVersion) && localVersion !== headerVersion && location.reload(true);
    },
    saveAnnouncement(headerAnnounce, localAnnounce) {
      //***** headerAnnounce의 state가 false || "false"이면 localStorage에 저장.
      if (!this.isUndefined(headerAnnounce) && (!headerAnnounce || headerAnnounce === 'false')) {
        localStorage.setItem('localAnnounce', JSON.stringify(headerAnnounce));
        localStorage.setItem('readAnnounce', JSON.stringify(headerAnnounce));
      }

      //***** localAnnounce와 headerAnnounce 비교후 다르다면 localStorage에 저장.
      else if (!this.isUndefined(headerAnnounce) && localAnnounce !== headerAnnounce) {
        localStorage.setItem('localAnnounce', JSON.stringify(headerAnnounce));
      }
    },
    showAnnouncementRedDot(headerAnnounce, readAnnounce) {
      //***** 공지버튼을 눌렀을때의 값과 헤더에서 넘어온 값이 같거나 헤더의 값이 false라면 빨간점 삭제.
      (!this.isUndefined(headerAnnounce) && String(readAnnounce) === String(headerAnnounce)) ||
      !headerAnnounce ||
      headerAnnounce === 'false'
        ? this.$store.commit('readAnnounce')
        : this.$store.commit('newAnnounce');
    },
    FCMtoken(str) {
      this.$cookies.set('fcmToken', str);
      // alert(`FCM token has been saved on Web Client: ${str}`);
      // alert(`Please move to Sign in.`);
    },
    getDegree() {
      const screenHeight = window.innerHeight - 80;
      const screenWidth = window.innerWidth - 250;

      // const a = {
      //   x: 0,
      //   y: 0,
      // };
      // const b = {
      //   x: screenWidth,
      //   y: screenHeight,
      // };

      // const x = b.x - a.x;
      // const y = b.y - a.y;

      const radian = Math.atan2(screenHeight, screenWidth);
      const degree = this.isMobile ? Math.floor((radian * 180) / Math.PI) * -1 : -50;

      return `${degree}deg`;
    },
    getDiagonal() {
      const screenHeight = window.innerHeight / 2 - 80;
      const screenWidth = window.innerWidth / 2 - 90;

      const diagonal = this.isMobile
        ? Math.floor(Math.sqrt(screenHeight ** 2 + screenWidth ** 2))
        : (65 / 100) * window.innerHeight;

      return `${diagonal}px`;
    },
    clickConfirm() {
      // 랜딩 페이지일 경우 로그인 페이지로 이동
      this.$store.dispatch('logout');
      this.$bvModal.hide('login-required');
      this.$router.push({ name: 'Login' });
    },
    confirmNiceId() {
      if (!this.niceAuth) {
        this.$bvModal.hide('nice-id-check');
        this.$nice_id();
      } else {
        this.$bvModal.hide('nice-id-check');
      }
    },
    clickCancel(str) {
      if (str == 'login-required') {
        // 랜딩 페이지일 경우 모달만 닫기
        if (this.$route.path.includes('/event/landing')) return this.$bvModal.hide(str);
        this.$store.dispatch('logout');
        if (this.$route.path.includes('/event/whiteday')) this.$router.push({ name: 'Main' });
      }
      this.$bvModal.hide(str);
    },
    clickLogout() {
      this.$bvModal.hide('logout');
      this.$store.dispatch('logout').then(() => {
        this.$store.commit('sidebar', { mode: 'close' });
        if (this.$route.path == '/main') {
          // location.reload(true);
        } else {
          this.$router.push({ name: 'Main' });
        }
      });
    },
    // goToRegist() {
    //   this.$bvModal.hide('nyc-open-event-win-modal');
    //   this.$router.push({ name: 'MyBuildings' });
    // },
  },
};
</script>

<!-- <style lang="scss">
#nyc-open-event-win-modal___BV_modal_outer_ {
  #nyc-open-event-win-modal {
    .nyc-open-event-win-modal {
      .modal-content {
        border-radius: 15px;
        overflow: hidden;
        .modal-body {
          padding: 0;
        }
      }
    }
  }
}
</style> -->

<style lang="scss">
@import './src/assets/scss/main';
@import '~bootstrap-vue/src/index';
</style>

<style lang="scss" scoped>
// floating animation
@keyframes floating {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}

#app-wrapper {
  height: 100%;
  .floating {
    position: fixed;
    right: calc(50% - 535px);
    bottom: min(10%, 20px);
    background: url($s3-url + '/img/common/event/landing/new/landing_floating.webp?' + $version) no-repeat center center;
    background-size: contain;
    padding: 20px;
    border-radius: 40px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    animation: floating 1s infinite;
    width: 120px;
    height: 120px;
    z-index: 99;
    &.double {
      bottom: 100px;
    }
    @include tablet {
      background: url($s3-url + '/img/common/event/landing/new/landing_floating_mobile.webp?' + $version) no-repeat
        center center;
      background-size: contain;
      right: 10px;
      bottom: 10px;
      width: 80px;
      height: 80px;
      &.double {
        bottom: 65px;
      }
      &.main {
        bottom: 65px;
      }
    }
  }
}
#nyc-open-event-win {
  position: relative;

  img {
    &.fireworks {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      pointer-events: none;
      z-index: 0;
      transform: translateY(-50%);
    }
    &.winner {
      position: relative;
      width: 100%;
      pointer-events: none;
      z-index: 1;
    }
  }
  button.go-to-regist {
    position: absolute;
    bottom: 8%;
    left: 50%;
    width: 80%;
    z-index: 2;
    font-weight: 400;
    font-size: 18px;
    transform: translate(-50%, -50%);
    background: #052153;
    border-radius: 3px;
    color: #ffffff;
    height: clamp(42px, 4.2vw, 52px);
  }
}
</style>
